
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSchema]/purchase_seats",
      function () {
        return require("private-next-pages/[teamSchema]/purchase_seats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSchema]/purchase_seats"])
      });
    }
  